import { render, staticRenderFns } from "./CombinedTotal.vue?vue&type=template&id=4bc969b1&"
import script from "./CombinedTotal.vue?vue&type=script&lang=js&"
export * from "./CombinedTotal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports